export const styles = ({
    container: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    }
});
